import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { usePhoneInput } from "@whoosh/design-system/src/components/controls/PhoneInput/hooks/usePhoneInput";
import { Avatar } from "@whoosh/design-system/src/components/display";
import {
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

import { ProfileInfo_ClientProfile$key } from "./__generated__/ProfileInfo_ClientProfile.graphql";

type ProfileInfoProps = {
  setEditMode: (val: boolean) => void;
  fragmentRef: ProfileInfo_ClientProfile$key;
};

const ProfileInfo = ({ setEditMode, fragmentRef }: ProfileInfoProps) => {
  const data = useFragment(ProfileInfoFragmentString, fragmentRef);
  const member = data.member;
  const defaultCountryId = data.member?.user?.phoneNumber?.countryCode;

  const { countryCode, maskPhoneNumber } = usePhoneInput({
    onChange: () => {},
    defaultCountryId,
  });

  const phoneNumber =
    maskPhoneNumber(
      data.member?.user?.phoneNumber?.nationalNumber,
      countryCode?.regionCode
    ) || "";

  return (
    <HStack mb={8} pt={6}>
      <Avatar
        size="lg"
        firstName={member?.user?.firstName || ""}
        lastName={member?.user?.lastName || ""}
        profileImagePublicId={member?.profileImage?.publicId}
        type="member"
      />
      <VStack ml={6} gap={2} flex={1}>
        <Text variant="mainBaseMedium" color="text-secondary" numberOfLines={1}>
          {member?.user?.email || ""}
        </Text>
        <Text variant="mainBaseMedium" color="text-secondary" numberOfLines={1}>
          {phoneNumber}
        </Text>
      </VStack>
    </HStack>
  );
};

export default ProfileInfo;

export const ProfileInfoFragmentString = graphql`
  fragment ProfileInfo_ClientProfile on ClientProfile {
    member {
      clientClass
      ... on Member {
        profileImage {
          # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
          publicId: renderingKey
        }
        user {
          email
          fullName
          firstName
          lastName
          phoneNumber {
            nationalNumber
            countryCode
          }
        }
      }
      ... on Customer {
        profileImage {
          # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
          publicId: renderingKey
        }
        user {
          fullName
          firstName
          lastName
          email
          phoneNumber {
            nationalNumber
            countryCode
          }
        }
      }
    }
  }
`;
